import { AppProvider } from "@shopify/polaris"
import "@shopify/polaris/build/esm/styles.css"
import translations from "@shopify/polaris/locales/en.json"
import { useCallback } from "react"

/**
 * Sets up the AppProvider from Polaris.
 * @desc PolarisProvider passes a custom link component to Polaris.
 * The Link component handles navigation within an embedded app.
 * Prefer using this vs any other method such as an anchor.
 * Use it by importing Link from Polaris, e.g:
 *
 * ```
 * import {Link} from '@shopify/polaris'
 *
 * function MyComponent() {
 *  return (
 *    <div><Link url="/tab2">Tab 2</Link></div>
 *  )
 * }
 * ```
 *
 * PolarisProvider also passes translations to Polaris.
 *
 */
export function PolarisProvider({ children }) {
	return <AppProvider i18n={translations}>{children}</AppProvider>
}
